<template>
    <div class="detail-wrap">
      <div class="title" v-text="preview.name"></div>
      <div class="info">{{preview.modifyTime}}</div>
      <div class="content">
        <div class="intr">
          <div class="group-summary" v-html="preview.describle"></div>
        </div>
      </div>
    </div>
</template>

<script >
  export default {
    props:{
      preview:{
        type:Object
      }

    }
  }
</script>

<style lang="scss" scoped>
  .detail-wrap {
    margin-top: 50px;
    height: 100%;
  }
  .title {
    color: #27292E;
    font-size: 28px;
    text-align: center;
  }
  .info {
    font-size: 12px;
    color: #757575;
    text-align: center;
    margin: 20px 0;
  }
  .content {
    display: flex;
    justify-content: center;
    .intr {
      width: 80%;
      max-width: 1200px;
      min-width: 400px;
      font-size: 14px;
      color: #757575;
      line-height: 1.8;
      word-break:break-all;
      overflow: hidden;
    }
    p{
      text-indent: 28px;
    }
    .thumbnail {
      margin: 20px 0;
      text-align: center;
      img {
        max-width: 100%;
        display: inline-block;
      }
    }
  }
  .group-summary {
    display: block;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif;
    font-size: 14px;
    word-break: break-all;
    color: #27292E;
    line-height: 1.5;
    * {
      display: -webkit-box;
      -webkit-line-clamp: 6;
      -webkit-box-orient: vertical;
      overflow: hidden;
      font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif;
      font-size: 14px;
      word-break: break-all;
      color: #b3b5ba;
      line-height: 2;
    }
  }
</style>
